// CragStatsControls.js
import React, { memo } from 'react';

export const CragStatsControls = memo(({ 
  numCrags, 
  setNumCrags, 
  selectedStat, 
  setSelectedStat 
}) => {
  const statOptions = [
    { value: 'cpg', label: 'Cumulative Grade' },
    { value: 'attempts', label: 'Total Attempts' },
    { value: 'cleanAscents', label: 'Clean Ascents' },
    { value: 'cleanRoutes', label:  'Clean Routes' }
  ];

  const limitOptions = [
    { value: 5, label: 'Top 5 Crags' },
    { value: 10, label: 'Top 10 Crags' },
    { value: 15, label: 'Top 15 Crags' },
    { value: 20, label: 'Top 20 Crags' },
    { value: 25, label: 'Top 25 Crags' },
    { value: 30, label: 'Top 30 Crags' }
  ];

  return (
    <>
      <select 
        value={numCrags} 
        onChange={(e) => setNumCrags(Number(e.target.value))}
        className="px-3 py-1.5 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {limitOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <select 
        value={selectedStat}
        onChange={(e) => setSelectedStat(e.target.value)}
        className="px-3 py-1.5 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {statOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
});

CragStatsControls.displayName = 'CragStatsControls';